<template>
  <div class="max-w-3xl mx-auto">
    <Head title="Crear marca" />
    
    <!-- Header -->
    <div class="mb-8">
      <div class="flex items-center gap-4 text-sm text-gray-500 mb-2">
        <button class="hover:text-orange-500 transition-colors" @click="back">
          <i class="fa fa-arrow-left" />
        </button>
        <Link href="/brands" class="hover:text-orange-500 transition-colors">Marcas</Link>
        <span class="text-gray-300">/</span>
        <span class="text-gray-900 font-medium">Crear</span>
      </div>
      
      <h1 class="text-2xl font-bold text-gray-900">Nueva Marca</h1>
      <p class="text-gray-500 mt-1">Registre una nueva marca en el sistema.</p>
    </div>

    <!-- Form -->
    <div class="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
      <form @submit.prevent="store">
        <div class="p-8">
          <h2 class="text-base font-bold text-gray-900 mb-6 flex items-center gap-2">
            <i class="fa fa-info-circle text-orange-500" />
            Información de la Marca
          </h2>
          
          <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
            <!-- Name -->
            <div class="space-y-1.5">
              <label class="block text-sm font-medium text-gray-700">Nombre *</label>
              <div class="relative">
                <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <i class="fa fa-tag text-gray-400" />
                </div>
                <input 
                  v-model="form.name"
                  type="text" 
                  class="block w-full pl-10 pr-3 py-2.5 bg-white border border-gray-200 rounded-lg focus:ring-orange-500 focus:border-orange-500 placeholder-gray-400 transition-colors text-sm"
                  :class="{'border-red-300': form.errors.name}"
                  placeholder="Ingrese el nombre de la marca"
                />
              </div>
              <p v-if="form.errors.name" class="text-red-500 text-xs mt-1">{{ form.errors.name }}</p>
            </div>

            <!-- Code -->
            <div class="space-y-1.5">
              <label class="block text-sm font-medium text-gray-700">Código</label>
              <div class="relative">
                <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <i class="fa fa-barcode text-gray-400" />
                </div>
                <input 
                  v-model="form.code"
                  type="text" 
                  class="block w-full pl-10 pr-3 py-2.5 bg-white border border-gray-200 rounded-lg focus:ring-orange-500 focus:border-orange-500 placeholder-gray-400 transition-colors text-sm"
                  :class="{'border-red-300': form.errors.code}"
                  placeholder="Ingrese el código de la marca"
                />
              </div>
              <p v-if="form.errors.code" class="text-red-500 text-xs mt-1">{{ form.errors.code }}</p>
            </div>
          </div>
        </div>

        <!-- Submit -->
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button 
            :loading="form.processing" 
            class="px-6 py-2 bg-orange-500 hover:bg-orange-600 text-white font-medium rounded-lg transition-colors flex items-center gap-2 shadow-sm"
            type="submit"
          >
            <i class="fa fa-plus-circle" />
            Crear marca
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  name: 'BrandCreate',
  
  components: {
    Head,
    Link,
    LoadingButton,
  },

  layout: Layout,

  remember: 'form',

  data() {
    return {
      form: this.$inertia.form({
        name: '',
        code: '',
      }),
    }
  },

  methods: {
    back() {
      window.history.back()
    },

    store() {
      this.form.post('/brands')
    },
  },
}
</script>
  
  